<template>
  <a-modal
    title="生成条码"
    v-model="visible"
    okText="生成条码"
    cancelText="取消"
    :bodyStyle="{ minHeight: '300px' }"
    width="800px"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item label v-show="false">
        <a-input v-decorator="['InvCode', { rules: [] }]" />
      </a-form-item>
      <a-form-item label v-show="false">
        <a-input v-decorator="['cbatch']" />
      </a-form-item>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ASN单号">
            <a-input placeholder="ASN单号" v-decorator="['Code']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="存货名称">
            <a-input placeholder="存货名称" v-decorator="['cinvname']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
            <a-input placeholder="数量" v-decorator="['iquantity']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="件数">
            <a-input placeholder="件数" v-decorator="['inum']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码规则">
            <a-select v-decorator="['BarRule']">
              <a-select-option v-for="(item, index, key) in barruleList" :value="item.ruleid" :key="key">{{ item.rulename }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码数依据">
            <a-select v-decorator="['BatchMode']" @change="e => ruleChange(e)">
              <a-select-option v-for="(item, index, key) in batchmodeList" :value="item.enumcode" :key="key">{{ item.enumname }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码个数">
            <a-input placeholder="数量" v-decorator="['BarCodeNum']" :disabled="issg" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码包装数量">
            <a-input placeholder="条码包装数量" @change="e => tmbzChange(e)" v-decorator="['BarCodeQty']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import { getBarRule, getBatchMode, getBarCodes, getASNByCCode } from '@/api/scmApi'
export default {
  name: 'ASNCode',
  data() {
    return {
      visible: false,
      autoid: null,
      form: this.$form.createForm(this),
      confirmLoading: false,
      barruleList: [],
      batchmodeList: [],
      issg: true,
      U8UserInfo: this.$store.getters.U8UserInfo,
      labelCol: { xs: { span: 24 }, sm: { span: 8 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } }
    }
  },
  computed: {
    hasSelectedCount() {
      return this.hasSelectedRecordsTemp.length
    }
  },
  mounted() {
    console.log('用户信息', this.$store.getters.U8UserInfo)
  },
  methods: {
    ruleChange(e) {
      const _that = this
      if (e === '数量') {
        _that.issg = true
        _that.form.setFieldsValue({ BarCodeNum: _that.form.getFieldValue('iquantity'), BarCodeQty: _that.form.getFieldValue('iquantity') })
      } else if (e === '件数') {
        _that.issg = true
        _that.form.setFieldsValue({ BarCodeNum: _that.form.getFieldValue('inum'), BarCodeQty: _that.form.getFieldValue('inum') })
      } else if (e === '手工输入') {
        _that.form.setFieldsValue({ BarCodeNum: 0, BarCodeQty: 0 })
        _that.issg = false
      }
    },
    tmbzChange(e) {
      const _that = this
      setTimeout(() => {
        if (_that.form.getFieldValue('BarCodeQty') != '0')
          _that.form.setFieldsValue({ BarCodeNum: Math.ceil(_that.form.getFieldValue('iquantity') / _that.form.getFieldValue('BarCodeQty')) })
        else _that.$message.warning('请输入大于0的整数')
      }, 1000)
    },
    handleCancel() {
      this.visible = false
    },
    //生成条码的方法
    toGetCode(ccode, selectedRows) {
      this.visible = true
      this.$nextTick(() => {
        this.form.resetFields()
        this.form.setFieldsValue({
          Code: ccode,
          InvCode: selectedRows[0].cinvcode,
          cinvname: selectedRows[0].cinvname,
          iquantity: selectedRows[0].iquantity,
          inum: selectedRows[0].inum,
          BarCodeNum: selectedRows[0].iquantity,
          BarCodeQty: selectedRows[0].iquantity,
          cbatch: selectedRows[0].cbatch
        })
      })
      this.autoid = selectedRows[0].autoid //从asn单查看界面进来后可以直接选到autoid
      this.loadInfo(ccode, selectedRows[0].cinvcode)
      // this.getAutoid(ccode) //从asn单维护界面进来时无法获得autoid，所以用该方法去调用
    },
    //开发版获取autoid
    // getAutoid(ccode) {
    //   getASNByCCode({ ccode: ccode })
    //     .then(res => {
    //       if (res.code === 0 || res.code === '0') {
    //         this.autoid = res.body[0].autoid
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //     .catch(function() {
    //       this.$message.error('获取ASN单信息发生异常!')
    //     })
    // },
    handleOk() {
      const _that = this
      this.confirmLoading = true
      if (_that.U8UserInfo) {
        _that.form.validateFields((err, values) => {
          if (!err) {
            values['VouchType'] = 'puas'
            values['autoid'] = _that.autoid
            values['Context'] = JSON.stringify(_that.U8UserInfo)
            debugger
            getBarCodes(values)
              .then(res => {
                if (res.code === 0 || res.code === '0') {
                  _that.$message.success('获取条码成功!')
                  _that.confirmLoading = false
                  _that.visible = false
                  _that.$emit('success')
                } else {
                  _that.$message.error(res.msg)
                  _that.confirmLoading = false
                }
              })
              .catch(function() {
                _that.$message.error('获取条码信息失败!')
                _that.confirmLoading = false
              })
          }
        })
      } else {
        _that.$message.warn('登录信息已过期,请重新登录!')
      }
    },
    loadInfo(ccode, cinvcode) {
      const _that = this
      getBarRule({ ccode: ccode, cinvcode: cinvcode })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.barruleList = res.data
            _that.form.setFieldsValue({ BarRule: _that.barruleList[0].ruleid })
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取条码规则发生异常!')
        })
      getBatchMode()
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.batchmodeList = res.data
            _that.form.setFieldsValue({ BatchMode: '手工输入' })
            _that.form.setFieldsValue({ BarCodeNum: 0, BarCodeQty: 0 })
            _that.issg = false
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取条码数依据发生异常!')
        })
    }
  }
}
</script>
